<template>
  <div class="documents-view mt-4">
    <div class="card border-0 shadow-sm documents-card">
      <div class="card-body">
        <div class="section-heading mb-3">
          <h6 class="mb-1">Lista de documentos</h6>
          <p class="text-sm text-muted mb-0">Consulta cada documento del usuario y actualiza su estado.</p>
        </div>

        <div class="table-responsive">
          <table class="table align-items-center table-sm documents-table mb-0">
            <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Documento</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado actual</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
            </tr>
            </thead>
            <tbody v-if="documents">
     <!--    ========================== Address -->
    <tr>
      <td>
        <span class="document-name">Dirección</span>
      </td>
      <td>
        <a :href="documents.address" target="_blank" rel="noopener noreferrer" v-if="documents.address" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.address_status)">{{ formatStatus(documents.address_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('address')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('address')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== BANK-->
    <tr>
      <td><span class="document-name">Banco</span></td>
      <td>
        <a :href="documents.bank" target="_blank" rel="noopener noreferrer" v-if="documents.bank" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.bank_status)">{{ formatStatus(documents.bank_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('bank')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('bank')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== Certificate-->
    <tr>
      <td><span class="document-name">Certificado</span></td>
      <td>
        <a :href="documents.certificate" target="_blank" rel="noopener noreferrer" v-if="documents.certificate" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.certificate_status)">{{ formatStatus(documents.certificate_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('certificate')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('certificate')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== Condonation-->
    <tr>
      <td><span class="document-name">Condonación</span></td>
      <td>
        <a :href="documents.condonation" target="_blank" rel="noopener noreferrer" v-if="documents.condonation" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.condonation_status)">{{ formatStatus(documents.condonation_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('condonation')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('condonation')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== Finger-->
    <tr>
      <td><span class="document-name">Huella</span></td>
      <td>
        <a :href="documents.finger" target="_blank" rel="noopener noreferrer" v-if="documents.finger" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.finger_status)">{{ formatStatus(documents.finger_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('finger')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('finger')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== ID BACK -->
    <tr>
      <td><span class="document-name">Identificación trasera</span></td>
      <td>
        <a :href="documents.id_back" target="_blank" rel="noopener noreferrer" v-if="documents.id_back" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.id_back_status)">{{ formatStatus(documents.id_back_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('id_back')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('id_back')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== ID FRONT -->
    <tr>
      <td><span class="document-name">Identificación frontal</span></td>
      <td>
        <a :href="documents.id_front" target="_blank" rel="noopener noreferrer" v-if="documents.id_front" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.id_front_status)">{{ formatStatus(documents.id_front_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('id_front')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('id_front')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== Selfie -->
    <tr>
      <td><span class="document-name">Selfie</span></td>
      <td>
        <a :href="documents.selfie" target="_blank" rel="noopener noreferrer" v-if="documents.selfie" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.selfie_status)">{{ formatStatus(documents.selfie_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('selfie')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('selfie')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
    <!--    ========================== Proroga -->
    <tr>
      <td><span class="document-name">Prórroga</span></td>
      <td>
        <a :href="documents.proroga" target="_blank" rel="noopener noreferrer" v-if="documents.proroga" class="btn btn-outline-primary btn-sm mb-0">Ver</a>
        <span v-else class="document-missing">No cargado</span>
      </td>
      <td>
        <span class="status-badge" :class="statusClass(documents.proroga_status)">{{ formatStatus(documents.proroga_status) }}</span>
      </td>
      <td>
        <div class="action-grid">
          <div>
            <select class="form-control btn-sm" @change="updateStatus('proroga')" v-model="status_selected">
               <option value="pending">Pendiente</option>
               <option value="rejected">Rechazado</option>
               <option value="approved">Aprobado</option>
             </select>
          </div>
          <div>
             <button class="btn btn-danger w-100 btn-sm" @click="deleteAccount('proroga')">Eliminar</button>
          </div>
        </div>
      </td>
    </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "Notes",
  data: () => ({
    user_id: null,
    documents: null,
    status_selected: '',
  }),
  mounted() {
    this.user_id = this.$route.query.id
    this.getDocuments()
  },
  methods:{
    formatStatus(status) {
      const map = {
        pending: 'Pendiente',
        rejected: 'Rechazado',
        approved: 'Aprobado',
      }
      return map[status] || status
    },
    statusClass(status) {
      return {
        'status-pending': status === 'pending',
        'status-rejected': status === 'rejected',
        'status-approved': status === 'approved',
      }
    },
    async getDocuments(){
      const {data} = await get(`documents/get-documents-by-user?id=${this.user_id}`)
      this.documents = data
    },
    async updateStatus(location){
      await post('documents/update-status',{id: this.user_id, status: this.status_selected, location: location})
      this.status_selected = "";
      await this.getDocuments()
      this.$swal({
        html: 'Procesado con éxito',
        icon: 'success',
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    async deleteAccount(location){
      this.$swal({
        html: '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post('documents/remove',{id: this.user_id, location: location})
          await this.getDocuments()
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.documents-card {
  border-radius: 1rem;
}

.section-heading h6 {
  font-size: 1rem;
  font-weight: 700;
}

.documents-table thead th {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.85rem;
}

.documents-table tbody tr td {
  vertical-align: middle;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-color: #edf2f7;
}

.document-name {
  font-weight: 600;
  color: #344767;
}

.document-missing {
  color: #ea0606;
  font-weight: 600;
}

.action-grid {
  display: grid;
  grid-template-columns: minmax(140px, 1fr) auto;
  gap: 0.75rem;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}

.status-pending {
  background: rgba(251, 207, 51, 0.18);
  color: #9a6700;
}

.status-rejected {
  background: rgba(234, 6, 6, 0.12);
  color: #c1121f;
}

.status-approved {
  background: rgba(130, 214, 22, 0.15);
  color: #4f8a10;
}

@media (max-width: 991px) {
  .action-grid {
    grid-template-columns: 1fr;
  }
}

</style>
